module.exports = __webpack_public_path__ + "media/img/arr-bt-bb753ebb25a1799177e6eba3254a94c8.svg";